var indentation_default = {
  "indentZero": "_1g8cS",
  "indentOne": "eFtwZ",
  "indentTwo": "jwGxm",
  "indentThree": "_0fyX5",
  "indentFour": "oYOsD",
  "indentFive": "gV0-B",
  "indentSix": "d68Bs"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
